import statuses from './index.js';

/* istanbul ignore next line */
const SET_LOADING_DASHBOARDS = (state, loadingDashboards) => {
  state.loadingDashboards = loadingDashboards;
};

const SET_DASHBOARDS = (state, dashboards) => {
  _.forEach(dashboards, d=> {
    d.nbElement = 0;
  })
  state.dashboards = dashboards;
  state.outDated = false;
};

const INVALIDATE_DASHBOARDS = (state) =>{
  state.outDated=true;
}

const UPDATE_DASHBOARD_TOTAL_ELEMENT = (state, { uuid, totalElement }) => {
  const dashboard = _.find(state.dashboards, d => d.uuid === uuid);
  if (dashboard != null) {
    dashboard.nbElement = totalElement;
  }
}

const DELETE_DASHBOARD = (state, id) => {
  const index = _.findIndex(state.dashboards, d => d.id === id);
  state.dashboards.splice(index, 1);
}

const ADD_DASHBOARD = (state, dashboard) =>  {
  state.dashboards.push(dashboard);
}

export default {
  SET_LOADING_DASHBOARDS,
  SET_DASHBOARDS,
  INVALIDATE_DASHBOARDS,
  UPDATE_DASHBOARD_TOTAL_ELEMENT,
  DELETE_DASHBOARD,
  ADD_DASHBOARD,
};
